import range from 'lodash/range';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {animationSpeedChange} from '../../../general/actionCreators';

const Label = gettext('Animation Speed');
const DataListID = 'animation-speed';
const MinimumSpeed = 10;
const MaximumSpeed = 100;
const SpeedInterval = 10;
const Speeds = range(MinimumSpeed, MaximumSpeed + 1, SpeedInterval);

const Speed = ({value, onChange}) => (
    <div>
        <input
            className="desktop-only"
            type="range"
            value={value}
            min={MinimumSpeed}
            max={MaximumSpeed}
            step={SpeedInterval}
            list={DataListID}
            onChange={onChange}
        />
        <datalist id={DataListID}>
            {Speeds.map(value => <option key={value} value={value}>{value}%</option>)}
        </datalist>
        <select className="met-select mobile-only" value={value} onChange={onChange} title={Label}>
            <optgroup label={Label}>
                {Speeds.map(value => <option key={value} value={value}>{value}%</option>)}
            </optgroup>
        </select>
    </div>
);

const mapStateToProps = ({animationSpeed: value}) => ({value});

const mapDispatchToProps = dispatch => ({
    onChange: ({currentTarget: {value}}) => dispatch(animationSpeedChange(+value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Speed);
